'use client';

import React from 'react';

const TraditionalApproaches = () => {
  const contrasts = [
    {
      traditional: 'Episodic change',
      required: 'Continuous change',
      explanation: 'Traditional change management assumes a beginning, middle, and end. AI-driven change is ongoing and requires sustained leadership capability.',
    },
    {
      traditional: 'Deployment focus',
      required: 'Adoption focus',
      explanation: 'Digital transformation prioritises technology modernisation and deployment. AI requires behavioural adoption and organisational readiness at scale.',
    },
    {
      traditional: 'Training programs',
      required: 'Leadership accountability',
      explanation: 'Training addresses skill gaps. AI adoption requires leadership alignment, governance structures, and accountability systems that sustain change.',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold font-headline text-[#0A2540] mb-12 leading-tight">
            Why Traditional Approaches Fall Short
          </h2>

          <div className="space-y-8 text-lg text-gray-800 font-body leading-relaxed mb-12">
            <p>
              Traditional change management, digital transformation, and AI strategy each address important aspects of organisational evolution. However, they were designed for different contexts and assumptions.
            </p>
            <p>
              <strong>Traditional change management</strong> assumes stable end states and discrete projects. It is optimised for episodic change, not continuous evolution.
            </p>
            <p>
              <strong>Digital transformation</strong> focuses on technology modernisation and system deployment. It defines what to build, not how organisations adapt.
            </p>
            <p>
              <strong>AI strategy</strong> articulates vision, priorities, and investment. It does not address the leadership, governance, and workforce systems required to execute at scale.
            </p>
          </div>

          <div className="space-y-6">
            {contrasts?.map((contrast, index) => (
              <div key={index} className="bg-white border-2 border-gray-200 p-8">
                <div className="grid md:grid-cols-2 gap-6 mb-4">
                  <div>
                    <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Traditional Model</span>
                    <p className="text-xl font-bold text-gray-600 mt-2">{contrast?.traditional}</p>
                  </div>
                  <div>
                    <span className="text-sm font-semibold text-[#0A2540] uppercase tracking-wider">AI Requires</span>
                    <p className="text-xl font-bold text-[#0A2540] mt-2">{contrast?.required}</p>
                  </div>
                </div>
                <p className="text-lg text-gray-800 leading-relaxed">
                  {contrast?.explanation}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TraditionalApproaches;